/* External */
import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import some from 'lodash-es/some';

/* Components */
import TracksMenu from '../TracksMenu/TracksMenu';

const disabledSubtitlesTrack = {
  id: 'off',
  iso: 'off',
};

function SubtitleTracksMenu({
  tracks,
  onSelectTrack,
  onDisableSubtitles,
  title,
  getLanguageLabel,
}) {
  const isAnyTrackSelected = useMemo(
    () => some(tracks, 'isSelected'),
    [tracks],
  );

  const tracksWithOff = useMemo(
    () => [
      {
        ...disabledSubtitlesTrack,
        isSelected: !isAnyTrackSelected,
      },
      ...tracks,
    ],
    [isAnyTrackSelected, tracks],
  );

  const onSelectTrackCallback = useCallback(
    (track) => {
      if (track.id === disabledSubtitlesTrack.id) {
        onDisableSubtitles();
      } else {
        onSelectTrack(track);
      }
    },
    [onSelectTrack, onDisableSubtitles],
  );

  return (
    <TracksMenu
      title={title}
      tracks={tracksWithOff}
      onSelectTrack={onSelectTrackCallback}
      getLanguageLabel={getLanguageLabel}
    />
  );
}

SubtitleTracksMenu.propTypes = {
  tracks: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    isSelected: PropTypes.bool,
  })),
  onSelectTrack: PropTypes.func,
  onDisableSubtitles: PropTypes.func,
  title: PropTypes.string,
  getLanguageLabel: PropTypes.func,
};

SubtitleTracksMenu.defaultProps = {
  tracks: [],
  onSelectTrack() {},
  onDisableSubtitles() {},
  title: '',
  getLanguageLabel() {},
};

export default SubtitleTracksMenu;
